<div class="save pointer flex-direction-revers-by-dir-he" *ngIf="name$() && ((!this.isUnauthorized$()) || (this.isUnauthorized$() && !!this.isFilterField$()))  else disableName" (click)="openChooseRecipientsPopup()">
    <img src="/assets/images/publish.svg" />
    <p translate>header.send</p>
</div> 
<ng-template #disableName>
    <div class="save pointer flex-direction-revers-by-dir-he disable">
        <img src="/assets/images/publish.svg" />
        <p translate>header.send</p>
        <div class="tooltip top">
            <!-- <div class="trigangular">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 8" fill="none">
                    <path d="M1.8983 5.5L6 0.763763L10.1017 5.5L1.8983 5.5Z" fill="#172134" stroke="#5E6471" />
                    <path d="M10.0059 6L9.00586 5L3.00586 5L2.00586 6L10.0059 6Z" fill="#172134" />
                </svg>
            </div> -->
            <div class="warp">
                <p  *ngIf="!name$()" translate>tooltipMesage.disabledShareByName</p>
                <p  *ngIf="name$() && !this.isfilterFieldInUnauthorized$()" translate>tooltipMesage.disabledShareByFilter</p>
            </div>
        </div>
    </div>

</ng-template>
<!-- [ngClass]="{'disable':(isDisable$ | async)==true}" 
(click)="isDisableSignal$()?null:openChooseRecipientsPopup()" -->